import React, {useState, useRef, useEffect} from 'react';
import * as properties from '../../elementsPropertiesItems';
// import Icons from '../../../Icons/Icons';
import { isSet } from '../../../../Utils/CommonFunctions';
import { SketchPicker } from 'react-color';
// import elementsProperties from './elementsProperties';


const Divider = (props)=>{
    const {path,keyParam,alignTypes,elementData} = props;

    
    let borderColor = (isSet(elementData.attributes.color,null)!==null)?elementData.attributes.color:'#000000'; 
    let borderLine = (isSet(elementData.attributes.borderLine,null)!==null)?elementData.attributes.borderLine:'solid';     

    const [showPicker, setShowPicker] = useState(false);
    const colorPickerRef = useRef(null);

    const handleDocumentClick = (event) => {
        if (colorPickerRef.current && !colorPickerRef.current.contains(event.target)) {
            setShowPicker(false);
            // console.log('sss');
        }
      };

    useEffect(() => {
        if(showPicker===true){
            document.addEventListener('click', handleDocumentClick);
        }       
        return () => {
          document.removeEventListener('click', handleDocumentClick);
        };
    }, [showPicker]);

    const handleChangeComplete = (colorval) => {
        // console.log('colorval',colorval);
        //props.changeHandler(path,keyParam,colorval.hex);
        props.changeHandler('.attributes','color',colorval.hex); 
        let fullLineVal = '1px '+borderLine+' '+colorval.hex;
        props.changeHandler(path,keyParam,fullLineVal);
        // setColor(newColor.hex);
    };

    const handleIconClick = () => {
        setShowPicker(!showPicker);
    };
    
    const changeHandler = (e,getAttr) => {
        const {value} = e.target;        
        props.changeHandler('.attributes','borderStyle',value);
        let fullLineVal = '1px '+value+' '+borderColor;
        props.changeHandler(path,keyParam,fullLineVal);        
    }  

    return(
        <div className="w-100">
            <div className="input-group mb-3">  
                <div className="input-group-prepend">
                    <span className="input-group-text text-truncate" style={{minWidth:'100px'}}>Color</span>
                </div>
                <div style={{ position: 'relative' }}>
                  <span
                    onClick={handleIconClick}
                    className="colorinput-color"
                    style={{ cursor: 'pointer', backgroundColor: borderColor, zIndex: showPicker ? 1 : 'auto' }}
                  ></span>
                  {showPicker && (
                    <div
                      className="color-pallet-modal"
                      style={{
                        position: 'absolute',
                        top: '40px',
                        right: '0',
                        zIndex: 99999,
                      }}
                      ref={colorPickerRef}
                    >
                      <SketchPicker color={borderColor} onChangeComplete={handleChangeComplete} />
                    </div>
                  )}
                </div>              
                {/*<input type="text" className="form-control" value={borderColor} onChange={e=>changeHandler(e,'color')} />*/}                
            </div>
            <div className="input-group mb-3">  
                <div className="input-group-prepend">
                    <span className="input-group-text text-truncate" style={{minWidth:'100px'}}>Style</span>
                </div> 
                <select className="form-control input-border-bottom1" onChange={e=>changeHandler(e,'borderLine')}> 
                    {
                        properties.BorderLineTypes.map((item,ind)=>{
                            let isSelected = '';
                            if(item.value === borderLine){
                               isSelected = 'selected';
                            }
                            return(
                                <option selected={isSelected} value={item.value}> {item.label} </option>    
                            )
                        })
                    }                    
                </select>             
                               
            </div>             
        </div>
    )
}


export default Divider;